import Client from './client';

export default class OnboardingAuditReports extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organizationId, options = {}) {
    return this.makeRequest(`${this.host}/internal/${organizationId}/onboarding/audit`, options);
  }

}
